import React from "react";
import { CDKRawDataFieldsToHide } from "../../constants";
import { isMasterClient } from "../../services/accountService";

export const CDKOrderDetailsPanel = ({ order, width, jwtInfo }) => {
  const singleOrderHeaders = Object.keys(order.originalCDKData);
  const mergedOrderHeaders = Object.keys(order.originalCDKData).sort((a, b) => {
    return a === "invoiceNumber" ? -1 : 1;
  });

  const headers = order.isMergedOrder ? mergedOrderHeaders : singleOrderHeaders;

  return (
    <div
      style={{
        maxWidth: width + "px",
        // backgroundColor: "yellow",
        margin: "auto",
      }}
    >
      <div
        className="paper-panel-tight order-details-panel CDK-details-panel p-0"
        style={{
          borderRadius: "6px",
          // backgroundColor: "red",
          //   width: "100%",
          //   maxWidth: "100%",
        }}
      >
        <table>
          <thead>
            <tr>
              {headers.map((field, index) => {
                return CDKRawDataFieldsToHide.includes(field) &&
                  !isMasterClient(jwtInfo) ? null : (
                  <th
                    key={field}
                    className={`CDK-details-panel-raw-vertical-border p-0 ${
                      field === "invoiceNumber" &&
                      order.isMergedOrder &&
                      "sticky-table-column-x border-right-none-imp"
                    }`}
                    style={
                      field === "invoiceNumber" && order.isMergedOrder
                        ? {
                            position: "sticky",
                            left: 0,
                            backgroundColor: "white",
                            // boxShadow: "0px 0px 6px 6px black",
                          }
                        : {}
                    }
                  >
                    <div
                      className={`py-3 px-4 ${
                        field === "invoiceNumber" && order.isMergedOrder
                          ? "CDK-details-panel-border-right"
                          : ""
                      }`}
                      // style={
                      //   field === "invoiceNumber" && order.isMergedOrder
                      //     ? {
                      //         // boxShadow: "5px 0px 5px -3px black"
                      //         borderRight: "1px solid rgba(150,150,150)",
                      //       }
                      //     : {}
                      // }
                    >
                      {field}
                    </div>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {order.isMergedOrder ? (
              order.originalRows.map((originalRowData) => {
                return (
                  <tr key={originalRowData.dataToSubmit.invoiceNumber}>
                    {headers.map((field, index) => {
                      return CDKRawDataFieldsToHide.includes(field) &&
                        !isMasterClient(jwtInfo) ? null : (
                        <td
                          key={field}
                          className={`CDK-details-panel-raw-vertical-border p-0 ${
                            field === "invoiceNumber" &&
                            order.isMergedOrder &&
                            "sticky-table-column-x border-right-none-imp"
                          }`}
                          style={
                            field === "invoiceNumber" && order.isMergedOrder
                              ? {
                                  height: "1px", //weird hack to get child to fit 100% but somehow the td still expands like normal to stay consistent with the row height
                                  // boxShadow: "6px 0px 5px -5px black",
                                  backgroundColor: "white",
                                  // border: "none",
                                }
                              : { height: "100%" }
                          }
                        >
                          <div
                            className={`py-3 px-4 ${
                              field === "invoiceNumber" && order.isMergedOrder
                                ? "h-100 CDK-details-panel-border-right"
                                : ""
                            }
                        `}
                            // style={
                            //   field === "invoiceNumber" && order.isMergedOrder
                            //     ? {
                            //         height: "100%",
                            //         borderRight: "1px solid rgb(150,150,150)",
                            //       }
                            //     : {}
                            // }
                          >
                            {originalRowData.originalCDKData[field]}
                          </div>
                        </td>
                      );
                    })}
                  </tr>
                );
              })
            ) : (
              <tr>
                {headers.map((field, index) => {
                  return CDKRawDataFieldsToHide.includes(field) &&
                    !isMasterClient(jwtInfo) ? null : (
                    <td
                      key={field}
                      className="CDK-details-panel-raw-vertical-border py-3 px-4"
                    >
                      {order.originalCDKData[field]}
                    </td>
                  );
                })}
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
